<template>
    <div ref="scrollTarget"></div>
    <div class="container statistics-page">
        <h2 class="stats-page-title">Statistiques</h2>

        <!-- KPI cards: Shipments -->
        <h3 class="stats-section-title">Expéditions</h3>
        <div class="row kpi-row">
            <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div class="kpi-card kpi-primary">
                    <div class="kpi-label">Expéditions totales</div>
                    <div class="kpi-value">{{ shipments_total }}</div>
                    <div class="kpi-sub">Livrées&nbsp;: {{ shipments_delivered }} ({{ delivered_rate }}%)</div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div class="kpi-card kpi-info">
                    <div class="kpi-label">En cours</div>
                    <div class="kpi-value">{{ shipments_progress }}</div>
                    <div class="kpi-sub">Ramassées&nbsp;: {{ shipments_pickup }} · Non ramassées&nbsp;: {{ shipments_not_pickup }}</div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div class="kpi-card kpi-warning">
                    <div class="kpi-label">En attente</div>
                    <div class="kpi-value">{{ shipments_pending }}</div>
                    <div class="kpi-sub">{{ pending_rate }}% du total</div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div class="kpi-card kpi-success">
                    <div class="kpi-label">Livrées</div>
                    <div class="kpi-value">{{ shipments_delivered }}</div>
                    <div class="kpi-sub">{{ delivered_rate }}% du total</div>
                </div>
            </div>
        </div>

        <!-- KPI cards: Service points -->
        <h3 class="stats-section-title">Points relais</h3>
        <div class="row kpi-row">
            <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div class="kpi-card kpi-secondary">
                    <div class="kpi-label">Points relais (total)</div>
                    <div class="kpi-value">{{ service_points }}</div>
                    <div class="kpi-sub">Actifs&nbsp;: {{ service_points_active }} ({{ active_servicepoints_rate }}%)</div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div class="kpi-card kpi-success">
                    <div class="kpi-label">Points relais actifs</div>
                    <div class="kpi-value">{{ service_points_active }}</div>
                    <div class="kpi-sub">Taux&nbsp;: {{ active_servicepoints_rate }}%</div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div class="kpi-card kpi-secondary">
                    <div class="kpi-label">Points relais inactifs</div>
                    <div class="kpi-value">{{ service_points_not_active }}</div>
                    <div class="kpi-sub">Sur un total de&nbsp;: {{ service_points }}</div>
                </div>
            </div>
        </div>

        <!-- KPI cards: Invoices -->
        <h3 class="stats-section-title">Factures</h3>
        <div class="row kpi-row">
            <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div class="kpi-card kpi-secondary">
                    <div class="kpi-label">Factures (total)</div>
                    <div class="kpi-value">{{ invoices_total_count }}</div>
                    <div class="kpi-sub">Remboursements&nbsp;: {{ refunds_total_count }}</div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div class="kpi-card kpi-success">
                    <div class="kpi-label">Factures payées</div>
                    <div class="kpi-value">{{ invoices_paid_count }}</div>
                    <div class="kpi-sub">Encaissement&nbsp;: € {{ Number(invoices_paid_total).toFixed(2) }}</div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div class="kpi-card kpi-danger">
                    <div class="kpi-label">Factures impayées</div>
                    <div class="kpi-value">{{ invoices_unpaid_count }}</div>
                    <div class="kpi-sub">En attente&nbsp;: € {{ Number(unpaid_invoices_total).toFixed(2) }}</div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div class="kpi-card kpi-secondary">
                    <div class="kpi-label">Remboursements</div>
                    <div class="kpi-value">{{ refunds_total_count }}</div>
                    <div class="kpi-sub">Total remboursements</div>
                </div>
            </div>
        </div>

        <!-- KPI cards: Collected cash from shipments (cash payments) -->
        <h3 class="stats-section-title">Espèces (colis payés en cash)</h3>
        <div class="row kpi-row">
            <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div class="kpi-card kpi-primary">
                    <div class="kpi-label">Colis payés en cash</div>
                    <div class="kpi-value">{{ cash_shipments_count }}</div>
                    <div class="kpi-sub">Collectés&nbsp;: {{ cash_shipments_paid_count }}</div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div class="kpi-card kpi-info">
                    <div class="kpi-label">Cash à encaisser</div>
                    <div class="kpi-value">€ {{ Number(cash_to_collect_total).toFixed(2) }}</div>
                    <div class="kpi-sub">Total dû par les agents</div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div class="kpi-card kpi-success">
                    <div class="kpi-label">Cash encaissé</div>
                    <div class="kpi-value">€ {{ Number(cash_collected_total).toFixed(2) }}</div>
                    <div class="kpi-sub">Reçu en comptabilité</div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                <div class="kpi-card kpi-warning">
                    <div class="kpi-label">Cash en attente</div>
                    <div class="kpi-value">€ {{ Number(cash_pending_total).toFixed(2) }}</div>
                    <div class="kpi-sub">Reste à encaisser</div>
                </div>
            </div>
        </div>
    </div>
  </template>
    
  <script>
  import axios from 'axios'
  import { toast } from 'bulma-toast'
  import Swal from 'sweetalert2'
  import { loadStripe } from '@stripe/stripe-js';
  
  
  export default {
    name: 'Dashboard',
    data() {
      return {
        shipments_total: "",
        shipments_progress: "",
        shipments_pickup: "",
        shipments_not_pickup: "",
        shipments_pending: "",
        shipments_delivered: "",
        service_points: "",
        service_points_active: "",
        service_points_not_active: "",
  
        delivered_rate: 0,
        pending_rate: 0,
        active_servicepoints_rate: 0,

        invoices_total_count: 0,
        invoices_paid_count: 0,
        invoices_unpaid_count: 0,
        invoices_paid_total: 0,
        unpaid_invoices_total: 0,
        refunds_total_count: 0,

        cash_shipments_count: 0,
        cash_shipments_paid_count: 0,
        cash_to_collect_total: 0,
        cash_collected_total: 0,
        cash_pending_total: 0,
      }
    },

    async mounted() {
      document.title = 'Tableau de bord | Eurekali';
      const element = this.$refs.scrollTarget;
      element.scrollIntoView({ behavior: 'smooth' });
      window.scrollTo(0, 0);
  
      await this.getStatistics();  
    },
    methods: {
      async getStatistics() {
        await axios.post('/api/v1/admin/get-statistics/')
          .then(response => {
            this.shipments_total = response.data['shipments_total']
            this.shipments_progress = response.data['shipments_progress']
            this.shipments_pickup = response.data['shipments_pickup']
            this.shipments_not_pickup = response.data['shipments_not_pickup']
            this.shipments_pending = response.data['shipments_pending']
            this.shipments_delivered = response.data['shipments_delivered']
            this.service_points = response.data['service_points']
            this.service_points_active = response.data['service_points_active']
            this.service_points_not_active = response.data['service_points_not_active']

            this.delivered_rate = response.data['delivered_rate']
            this.pending_rate = response.data['pending_rate']
            this.active_servicepoints_rate = response.data['active_servicepoints_rate']

            this.invoices_total_count = response.data['invoices_total_count']
            this.invoices_paid_count = response.data['invoices_paid_count'] ?? 0
            this.invoices_unpaid_count = response.data['invoices_unpaid_count']
            this.invoices_paid_total = response.data['invoices_paid_total'] ?? 0
            this.unpaid_invoices_total = response.data['unpaid_invoices_total']
            this.refunds_total_count = response.data['refunds_total_count']

            this.cash_shipments_count = response.data['cash_shipments_count'] ?? 0
            this.cash_shipments_paid_count = response.data['cash_shipments_paid_count'] ?? 0
            this.cash_to_collect_total = response.data['cash_to_collect_total'] ?? 0
            this.cash_collected_total = response.data['cash_collected_total'] ?? 0
            this.cash_pending_total = response.data['cash_pending_total'] ?? 0
          })
          .catch(error => {
  
            toast({
              message: 'Failed to get Statistics',
              type: 'is-danger',
              dismissible: true,
              pauseOnHover: true,
              duration: 2000,
              position: 'top-right',
            })
            console.log(JSON.stringify(error))
          })
      },
      
      
    
    
    }
  }
  </script>
    
  <style scoped>
  .statistics-page { padding-bottom: 3rem; background-color: #F7F7F8; min-height: 100vh; padding-top: 1.5rem; }
  .stats-page-title { color: #333; font-weight: 700; margin-bottom: 1.5rem; font-size: 1.75rem; }
  .stats-section-title {
    margin-top: 1.5rem;
    margin-bottom: 0.75rem;
    font-size: 1rem;
    font-weight: 600;
    color: #555;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }
  .kpi-row { margin-bottom: 1rem; }
  .kpi-card {
    background: #fff; border-radius: 12px; padding: 1.25rem 1.5rem;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08); border-left: 4px solid #E5097F;
    height: 100%; min-height: 120px; display: flex; flex-direction: column; justify-content: center;
  }
  .kpi-card .kpi-label { font-size: 0.85rem; font-weight: 600; color: #555; text-transform: uppercase; letter-spacing: 0.02em; margin-bottom: 0.5rem; }
  .kpi-card .kpi-value { font-size: 2rem; font-weight: 700; color: #222; line-height: 1.2; }
  .kpi-card .kpi-sub { font-size: 0.8rem; color: #666; margin-top: 0.35rem; }
  .kpi-card.kpi-primary { border-left-color: #E5097F; } .kpi-card.kpi-primary .kpi-value { color: #E5097F; }
  .kpi-card.kpi-info { border-left-color: #0d6efd; } .kpi-card.kpi-info .kpi-value { color: #0d6efd; }
  .kpi-card.kpi-warning { border-left-color: #fd7e14; } .kpi-card.kpi-warning .kpi-value { color: #fd7e14; }
  .kpi-card.kpi-success { border-left-color: #198754; } .kpi-card.kpi-success .kpi-value { color: #198754; }
  .kpi-card.kpi-secondary { border-left-color: #6c757d; } .kpi-card.kpi-secondary .kpi-value { color: #495057; }
  .kpi-card.kpi-danger { border-left-color: #dc3545; } .kpi-card.kpi-danger .kpi-value { color: #dc3545; }

  .custom {
    border: none;
    cursor: pointer;
    font-size: 15px;
    padding-bottom: 10px;
  
  }
  
  .custom:hover {
    color: #E5097F;
    font-weight: bold;
  }
  
  
  .active-item {
    color: #E5097F;
    font-weight: bold;
  }
  
  .img-item {
    margin-right: 3px;
  }
  
  .red-header tr {
    background-color: red;
    color: white;
  }
  
  .btn-new-ship {
    color: #E5097F;
    font-weight: bold;
    background-color: #fff;
    border: 2px solid #E5097F;
    border-radius: 20px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 2px;
    padding-top: 2px;
  }
  
  .btn-new-ship:hover {
    background-color: #9b0656;
    color: white;
    border: 2px solid #9b0656;
  }
  
  
  .btn-more {
    color: #fff;
    font-weight: bold;
    background-color: #E5097F;
    border: 2px solid #E5097F;
    margin-left: 10px;
    border-radius: 20px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 5px;
    padding-top: 5px;
  }
  
  .btn-pay {
    color: #fff;
    font-weight: 500;
    background-color: #E5097F;
    border: 2px solid #E5097F;
    border-radius: 20px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 0px;
    padding-top: 0px;
  }
  
  .btn-refund {
    color: #fff;
    font-weight: bold;
    background-color: #64C96B;
    border: 2px solid #64C96B;
    margin-left: 10px;
    border-radius: 20px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 5px;
    padding-top: 5px;
  }
  
  .btn-more-deactivate {
    color: #fff;
    font-weight: bold;
    background-color: #C4C4C4;
    border: 2px solid #C4C4C4;
    margin-left: 10px;
    border-radius: 20px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 5px;
    padding-top: 5px;
    cursor: not-allowed;
  }
  
  .btn-pay-deactivate {
    color: #fff;
    font-weight: 500;
    background-color: #C4C4C4;
    border: 2px solid #C4C4C4;
    border-radius: 20px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 0px;
    padding-top: 0px;
    cursor: not-allowed;
  }
  
  .btn-more:hover {
    background-color: #9b0656;
    border: 2px solid #9b0656;
  }
  
  .btn-pay:hover {
    background-color: #9b0656;
    border: 2px solid #9b0656;
  }
  
  .btn-refund:hover {
    background-color: #255c29;
    border: 2px solid #255c29;
  }
  
  .btn-request {
    background-color: #BCF2C0;
    margin-left: 12px;
    border-radius: 20px;
    border: 2px solid #37B980;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 5px;
    padding-top: 5px;
    font-weight: bold;
  }
  
  .btn-request:hover {
    background-color: #37B980;
    color: white;
  }
  
  
  .box-shadow-custom {
    box-shadow: 1px 1px 1px #aaa, -1px -1px 1px #aaa;
  }
  
  .text-green {
    color: #37B980;
  }
  
  .text-red {
    color: red;
  }
  
  .custom-background1 {
    position: relative;
    background-image: url('../assets/img/shipments_panding.svg');
    background-size: 25%;
    background-position: left bottom;
    background-repeat: no-repeat;
  }
  
  .custom-background2 {
    position: relative;
    background-image: url('../assets/img/shipments_progress.svg');
    background-size: 25%;
    background-position: left bottom;
    background-repeat: no-repeat;
  }
  
  .custom-background3 {
    position: relative;
    background-image: url('../assets/img/shipments_delivred.svg');
    background-size: 25%;
    background-position: left bottom;
    background-repeat: no-repeat;
  }
  
  .modal {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
  }
  
  .modal-body {
    display: flex;
    justify-content: space-between;
  }
  
  .column {
    width: 45%;
  }
  
  .modal-content {
    background-color: #FEEEF6;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 50%;
  }
  
  .close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }
  
  .close:hover,
  .close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
  }
  </style>
    